import { combineReducers } from '@reduxjs/toolkit'
import { get } from './get'
import { update } from './update'

export const crypto = combineReducers({
  get,
  update
})
